/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box, Collapse, Divider, IconButton, Typography } from '@mui/material';
import React from 'react';
import MaterialSymbol from '../../../components/MaterialSymbol';
import { colors } from '@farmlands/mui-theme';

interface CollapseSectionProps {
  children?: React.ReactNode | React.ReactNode[];
  defaultOpen: boolean;
  title: string;
}

const ExpandLess = () => <MaterialSymbol>expand_less</MaterialSymbol>;
const ExpandMore = () => <MaterialSymbol>expand_more</MaterialSymbol>;

const CollapseSection: React.FC<CollapseSectionProps> = (props) => {
  const [mainOpen, setMainOpen] = React.useState(props.defaultOpen);
  return (
    <Box>
      <Divider sx={{ mb: 2 }} />
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        onClick={() => setMainOpen(!mainOpen)}
        sx={{ cursor: 'pointer', mb: 2 }}
      >
        <Typography variant='h4' color={colors.shade100}>
          {props.title}
        </Typography>
        <IconButton>{mainOpen ? <ExpandLess /> : <ExpandMore />}</IconButton>
      </Box>
      <Collapse in={mainOpen} timeout='auto' unmountOnExit>
        {props.children}
      </Collapse>
    </Box>
  );
};

export default CollapseSection;
